import script from "./BookCardBackground.vue?vue&type=script&setup=true&lang=ts"
export * from "./BookCardBackground.vue?vue&type=script&setup=true&lang=ts"

import "./BookCardBackground.vue?vue&type=style&index=0&id=40604c10&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40604c10"]])

export default __exports__